import { errorFromResponse } from "./errors.js";
export async function getProjectFinancialHistory(id, { signal } = {}) {
  const response = await fetch(`/api/projects/${encodeURIComponent(id)}/financial-history`, { credentials: "include", signal });
  if (!response.ok) throw await errorFromResponse(response);
  const rows = await response.json();
  if (!Array.isArray(rows)) throw new Error("Invalid financial history response.");
  return rows;
}
